export default {
  "noImageURLReturned": "未返回图片地址",
  "imageUploaded": "图片已上传",
  "uploadFailed": "上传失败",
  "thisDesignHasUnsavedChangesSwitching": "当前设计尚未保存，切换将丢失未保存修改。是否继续？",
  "switchDesign": "切换设计",
  "home": "首页",
  "couldNotLoadHomeDesigns": "首页设计加载失败",
  "enterADesignName": "请输入设计名称",
  "newHomeDesign": "新增首页设计",
  "nameIsRequired": "名称不能为空",
  "homeDesignCreated": "已新增首页设计",
  "couldNotCreateDesign": "新增设计失败",
  "restoreThisDraftToTheDefault": "仅将当前设计的「草稿」还原为系统默认模板（保留设计名称，不改是否首页、不影响已发布的线上内容）。未保存的修改会丢失，是否继续？",
  "restoreDefault": "还原默认",
  "draftRestoredPublishAgainToUpdate": "草稿已还原为默认模板（线上页面需重新发布才会更新）",
  "couldNotRestoreDefault": "还原默认失败",
  "keepAtLeastOneHomeDesign": "至少保留一套首页设计",
  "currentDesign": "当前设计",
  "deleteDesign": "删除设计",
  "delete": "删除",
  "designDeleted": "设计已删除",
  "couldNotDeleteDesign": "删除设计失败",
  "theMiniProgramWillDisplayThis": "设为首页后，终端将展示该设计的「已发布」内容。请确认该设计已发布过。是否继续？",
  "setHome": "设为首页",
  "setAsHomePage": "已设为首页",
  "couldNotSetHomeDesign": "设为首页失败",
  "draftSaved": "草稿已保存",
  "couldNotSaveDraft": "草稿保存失败",
  "couldNotLoadDraftPreview": "草稿预览加载失败",
  "saveTheCurrentChangesBeforePublishing": "当前修改尚未保存，是否先保存草稿再发布？",
  "publishHome": "发布首页",
  "usersWillSeeThisDesignAfter": "发布后，终端用户将看到当前设计内容。确认发布？",
  "thisIsNotTheHomeDesign": "当前设计不是首页。发布只会更新本设计的线上版本；终端仍显示已设为首页的设计。确认发布？",
  "designPublished": "设计已发布",
  "couldNotPublishHomeDesign": "首页发布失败",
  "couldNotLoadHomeDraft": "首页草稿加载失败",
  "homePage": "首页装修",
  "selectAHomeDesign": "选择首页设计",
  "newDesign": "新增设计",
  "currentHome": "当前首页",
  "unsavedChanges": "尚未保存",
  "draftSaved1": "已保存草稿",
  "saveDraft": "保存草稿",
  "previewDraft": "预览草稿",
  "basic": "基础组件",
  "utilityComponents": "工具组件",
  "addComponentsFromTheLeft": "从左侧添加组件",
  "moveUp": "上移",
  "moveDown": "下移",
  "duplicate": "复制",
  "props": "属性",
  "titleBar": "标题栏设置",
  "designName": "设计名称",
  "pageTitle": "页面标题",
  "titleColor": "标题颜色",
  "black": "黑色",
  "white": "白色",
  "titleBarBackground": "标题栏背景",
  "contentArea": "内容区设置",
  "backgroundColor": "背景颜色",
  "reset": "重置",
  "backgroundImageURL": "背景图片地址",
  "upload": "上传",
  "verticalPadding": "上下边距",
  "horizontalPadding": "左右边距",
  "selectAComponentOnTheCanvas": "请选择画布中的组件",
  "draftPreview": "草稿预览",
  "noComponentsAdded": "暂未添加组件",
  "navigation": "导航",
  "cell": "格子",
  "carousel": "轮播",
  "image": "图片",
  "recommendedCarouselSize750360": "轮播图片建议尺寸750*360",
  "recommendedImageSize750360": "最佳图片尺寸750*360",
  "recommendedImageSize100100": "最佳图片尺寸100*100",
  "imageGridsSupportUpTo4": "魔方最大仅支持4张图片",
  "navigationTitle": "导航标题",
  "timelineEntry": "时间节点",
  "contentSettings": "内容设置",
  "imageURL": "图片地址",
  "content": "内容",
  "type": "类型",
  "selectAType": "请选择类型",
  "settings": "设置",
  "addNavigationItem": "添加导航",
  "addImage": "添加图片",
  "button": "按钮",
  "addButton": "+ 添加按钮",
  "title": "标题",
  "buttonText": "按钮文字",
  "buttonType": "按钮类型",
  "text": "文字",
  "icon": "图标",
  "videoURL": "视频地址",
  "coverImage": "封面图",
  "latitude": "纬度",
  "longitude": "经度",
  "placeholder": "占位文案",
  "announcement": "公告内容",
  "showIcon": "显示图标",
  "text2": "文本",
  "alignment": "对齐",
  "left": "左",
  "center": "中",
  "right": "右",
  "richTextContent": "富文本内容",
  "entry": "节点",
  "date": "日期",
  "addEntry": "添加节点",
  "selectIcon": "选择图标",
  "associationName": "协会名称",
  "iconURL": "图标地址",
  "height": "高度",
  "contentIsLoadedFromTheMini": "列表内容由小程序接口在运行时拉取，此处仅配置展示样式与条数。",
  "showTitle": "显示标题",
  "titleText": "标题文字",
  "rightButton": "右侧按钮",
  "itemCount": "展示条数",
  "showImages": "显示图片",
  "showViewCount": "显示阅读数",
  "showContactDetails": "显示联系方式",
  "noEditableContent": "暂无可编辑内容",
  "styleSettings": "样式设置",
  "slideIntervalMs": "切换时间（毫秒）",
  "componentHeight": "组件高度",
  "itemsPerRow": "每行数量",
  "iconSize": "图标大小",
  "columns": "列数",
  "mapHeight": "地图高度",
  "lineStyle": "线条样式",
  "solid": "实线",
  "dashed": "虚线",
  "dotted": "点状",
  "lineColor": "线条颜色",
  "fontSize": "字体大小",
  "textColor": "文字颜色",
  "buttonColor": "按钮颜色",
  "buttonSize": "按钮尺寸",
  "rightOffset": "右边距",
  "bottomOffset": "下边距",
  "opacity": "透明度",
  "componentCornerRadius": "组件圆角",
  "textSize": "文字尺寸",
  "fontColor": "字体颜色",
  "autoScroll": "自动滚动",
  "off": "关闭",
  "on": "开启",
  "scrollIntervalMs": "滚动间隔（毫秒）",
  "scrollDurationMs": "滚动速度（毫秒）",
  "iconSize3": "图标尺寸",
  "iconCornerRadius": "图标圆角",
  "cornerStyle": "圆角类型",
  "none": "无",
  "partial": "半",
  "full": "全",
  "positionBadgeRadius": "职位圆角",
  "positionFontSize": "职位尺寸",
  "positionTextColor": "职位颜色",
  "positionBackground": "职位背景",
  "nameFontSize": "姓名尺寸",
  "nameColor": "姓名颜色",
  "imageCornerRadius": "图片圆角",
  "enterSearchKeywords": "请输入关键词搜索",
  "recommendedWidth750AnyHeight": "建议宽度750, 高度不限",
  "singleImage": "单图",
  "icon4": "导",
  "imageGrid": "魔方",
  "infoCard": "信息卡片",
  "details": "查看详情",
  "viewMore": "查看更多",
  "videoComponent": "视频",
  "map": "地图 ·",
  "more": "更多",
  "member": "会员",
  "memberName": "会员姓名",
  "album": "相册",
  "exampleEventTitle": "活动名称（仅为示例）",
  "0101800Mon": "01/01 8:00 | 周一",
  "qingdaoShandong": "山东省青岛市",
  "exampleArticleTitleContentDependsOn": "这是文章标题（仅为示例，具体内容根据选择的新闻变化）",
  "example": "示例",
  "loadedFromTheMiniProgramAPI": "运行时由小程序接口拉取",
  "icon5": "协",
  "associationProfile": "商会介绍",
  "spacer": "留白",
  "notifications": "消息通知",
  "enterText": "请输入文本",
  "noticeTitle": "提示标题",
  "noticeContent": "提示内容",
  "icon6": "浮",
  "enterAnExternalURL": "请输入外部链接",
  "externalLink": "外部链接",
  "enterAPhoneNumber": "请输入电话号码",
  "miniProgramSupport": "小程序客服",
  "selectALinkType": "选择类型",
  "path": "路径",
  "pageParametersOptional": "页面参数（选填）",
  "eGId2": "例: id=2",
  "actions": "操作",
  "select": "选择",
  "1AddTheBusinessDomainBefore": "1. 必须添加业务域名，才可以跳转；",
  "2AddItInWeChatPublic": "2. 业务域名添加：微信公众平台 → 开发 → 开发管理 → 开发设置 → 业务域名",
  "enterAURL": "请输入链接",
  "phoneNumber": "电话号码",
  "description": "说明",
  "1AvailableOnlyInWeChatMini": "1. 仅微信小程序可用，其他平台无法使用",
  "2OpensCustomerSupportInThis": "2. 在本小程序打开小程序客服",
  "cancel": "取消",
  "oK": "确定",
  "informationCardTitle": "此处是信息卡片标题",
  "informationCardContent": "此处是信息卡片内容",
  "buttonText1": "按钮文字1",
  "buttonText2": "按钮文字2",
  "buttonText3": "按钮文字3",
  "news": "新闻资讯",
  "memberList": "会员列表",
  "associationEvents": "商会活动",
  "eventAlbums": "活动相册",
  "memberSupplyAndDemand": "会员供需",
  "thisIsACustomNotification": "这里是第一条来自后台自定义消息通知的信息",
  "textContentGoesHere": "这里是文本的内容",
  "spanRichTextContentGoesHere": "这里是富文本的内容",
  "membershipApplications": "申请入会",
  "editProfile": "编辑资料",
  "membershipFeePayments": "会费缴纳",
  "memberShowcase": "会员风采",
  "activityList": "活动列表",
  "eventDetails": "活动详情",
  "eGId2EventID": "例: id=2，活动 id",
  "myEvents": "我的活动",
  "listings": "供需列表",
  "supplyAndDemandDetails": "供需详情",
  "eGId2ListingID": "例: id=2，供需 id",
  "myPosts": "我的发布",
  "postSupplyOrDemand": "发布供需",
  "articles": "文章资讯",
  "articleDetails": "文章详情",
  "eGId2ArticleID": "例: id=2，文章 id",
  "fAQ": "常见问题",
  "settings7": "系统设置",
  "userAgreement": "用户协议",
  "privacyPolicy": "隐私政策",
  "membershipAgreement": "入会协议",
  "internalPage": "内部页面",
  "callPhone": "拨打电话",
  "message1": "{p0}（首页）",
  "message2": "首页设计{p0}",
  "message3": "「{p0}」是当前首页，删除后将自动把另一套设计设为首页，且草稿与发布记录一并清除。确认删除？",
  "message4": "确认删除「{p0}」？该设计的草稿与发布记录将一并清除。",
  "message5": "按钮文字{p0}",
  "message6": "按钮{p0}",
  "searchComponent": "搜索",
  "lineComponent": "线条",
  "floatComponent": "浮动按钮",
  "mapComponent": "地图"
}
